import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TrinityRoutingModule } from './trinity-routing.module';
import { TrinityComponent } from './trinity.component';
import { TrinityListComponent } from './trinity-list/trinity-list.component';
import { TrinityRequestComponent } from './trinity-request/trinity-request.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../core/material.module';
import { SharedModule } from '../shared/shared.module';
import { TrinityWidgetComponent } from './trinity-widget/trinity-widget.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NumberDirective } from './number.directive'; // Import this



@NgModule({
  declarations: [
    TrinityComponent,
    TrinityListComponent,
    TrinityRequestComponent,
    TrinityWidgetComponent,
    NumberDirective
  ],
  imports: [
    CommonModule,
    TrinityRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    DragDropModule,
    InfiniteScrollModule
  ],
  exports:[
    TrinityListComponent,
    TrinityRequestComponent
  ]
})
export class TrinityModule { }
